import React from 'react';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  padding?: boolean;
}

/**
 * 容器组件
 * 用于统一页面内容的最大宽度和居中对齐
 */
export const Container: React.FC<ContainerProps> = ({
  children,
  className = '',
  size = 'xl',
  padding = true,
}) => {
  // 尺寸样式
  const sizeClasses = {
    sm: 'max-w-2xl',
    md: 'max-w-4xl',
    lg: 'max-w-6xl',
    xl: 'max-w-7xl',
    full: 'max-w-full',
  };
  
  // 内边距样式
  const paddingClasses = padding ? 'px-4 sm:px-6 lg:px-8' : '';
  
  // 组合样式类
  const containerClasses = `mx-auto ${sizeClasses[size]} ${paddingClasses} ${className}`;
  
  return (
    <div className={containerClasses}>
      {children}
    </div>
  );
};